/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const BlogListPage = lazyLoad(
  () => import('./index'),
  module => module.BlogListPage
);
